import { Component, OnInit, inject } from '@angular/core';
import { TitleCasePipe, DatePipe } from '@angular/common';
import { UsersService } from '../../../core/services/users.service';
import { User } from '../../../core/models/user.model';
import { UserType } from '../../../core/enums/user-type.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { keyedUserRoleOptions } from 'app/core/options/user-role.opts';
import { UserHeaderComponent } from '../../components/user-header/user-header.component';
import { UserActionsComponent } from '../../components/user-actions/user-actions.component';
import { PhoneNumberComponent } from '../../../shared/components/phone-number/phone-number.component';
import { UserTypeComponent } from '../../../shared/components/user-type/user-type.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: 'app-capture-admin-user',
    templateUrl: './capture-admin-user.component.html',
    styleUrls: ['./capture-admin-user.component.scss'],
    imports: [UserHeaderComponent,
              UserActionsComponent,
              PhoneNumberComponent,
              UserTypeComponent,
              MatProgressSpinner,
              DatePipe,
              BlankValueDashPipe]
})
export class CaptureAdminUserComponent implements OnInit {
  private usersService = inject(UsersService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  user: User;
  loading = false;
  userTypes = UserType;
  keyedUserRoleOptions = keyedUserRoleOptions;

  ngOnInit() {
    this.init();
  }

  onUserChange(user: User) {
    this.user = user;
  }

  public assignedClients() {
    const clientNames = this.user.assignedClients.map(c => c.name).sort();
    return clientNames.map(c => new TitleCasePipe().transform(c)).join(', ');
  }

  private init() {
    const userId = this.route.snapshot.paramMap.get('id');
    this.loadUser(userId);
  }

  private loadUser(userId): void {
    this.loading = true;
    this.usersService.get(userId).subscribe(
      user => {
        this.user = user;
        this.loading = false;
      },
      (err: HttpErrorResponse) => {
        if (err.status === 404) {
          this.router.navigate(['/404'], { replaceUrl: true });
        } else {
          console.error(err);
        }
      }
    );
  }
}
